import "./src/styles/global.css"

export const onRouteUpdate = () => {
  document.body.style.overflow = ""
}